import { render, staticRenderFns } from "./ItemIntelTooltip.vue?vue&type=template&id=2a968ff6&"
import script from "./ItemIntelTooltip.vue?vue&type=script&lang=ts&"
export * from "./ItemIntelTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./ItemIntelTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports